<template>
  <div>
    <div>
      <!-----------------heading and buttons ---------------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" md="6">
          <h1 class="heading-1">Digital Manuals</h1>
        </v-col>
        <v-col cols="12" md="6">
          <div class="d-flex justify-end">
            <v-btn
              color="white"
              outlined
              @click="UploadManualDialog = true"
              dark
              style="background-color: #0071bd; border: 2px solid #0071bd"
              class="text_style ml-3 px-9"
            >
              Upload Manual
            </v-btn>

            <v-btn
              color="white"
              outlined
              to="/DigitalManual/version"
              dark
              style="background-color: #0071bd; border: 2px solid #0071bd"
              class="text_style ml-3 px-9"
            >
              Manual Version
            </v-btn>

            <!-- <v-btn
              color="primary"
              outlined
              dark
              class="text_style ml-3 px-9"
              to="/DigitalManual/Archived"
            >
              Archived
            </v-btn> -->
          </div>
        </v-col>
      </v-row>
      <!----------------- search and filter ---------------------->
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" xl="4">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                hide-details
                single-line
                @input="fetchData"
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!----------------- data table ---------------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="GetDigitalManuals"
          :search="search"
          :page.sync="page"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="Id"
          show-expand
          :items-per-page-text="itemsPerPage"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.title`]="{ item }">
            <span class="table_style_one">
              <b> {{ item.Title }} </b></span
            >
          </template>
          <template v-slot:[`item.numberOfVersion`]="{ item }">
            <span class="table_style_two">
              {{ item.DigitalManualFiles && item.VersionCount }}
            </span>
          </template>
          <template v-slot:[`item.numberOfLanguage`]="{ item }">
            <span class="table_style_two">
              {{ item.DigitalManualFiles && item.DigitalManualFiles.length }}
            </span>
          </template>
          <template v-slot:[`item.ModifiedDate`]="{ item }">
            <span class="table_style_two">{{
              checkDate(item.ModifiedDate)
            }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on" class="mx-3">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    @click="EditItem(item)"
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit </span>
                  </v-btn>
                </v-list>
                <!-- <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="GoToArchived(item)"
                  >
                    <v-icon color="#646464">mdi-archive-arrow-down</v-icon>
                    <span class="ml-4 text_style">Archive</span>
                  </v-btn>
                </v-list> -->
                <!-- <v-list class="px-3 pt-1" color="transparent">
                  <v-dialog v-model="dialog" persistent max-width="290">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="transparent"
                        block
                        @click="DeleteItem(item)"
                        class="d-flex justify-start"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="#646464">mdi-delete</v-icon>
                        <span class="ml-4 text_style">Delete</span>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5"> Warning </v-card-title>
                      <v-card-text class="index_span_2_style"
                        >Are you sure you want to delete?</v-card-text
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          text
                          @click="dialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn color="red darken-1" text @click="deletedialog">
                          Confirm
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list> -->
              </v-card>
            </v-menu>
          </template>

          <!-----------------Expanded data table ---------------------->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div style="display: none">More info about {{ item.id }}</div>
              <v-card class="my-6" outlined>
                <v-data-table
                  :headers="headers2"
                  :loading="tableLoader"
                  loading-text="Loading... Please wait"
                  :items="item.DigitalManualFiles"
                  :search="''"
                  item-key="Id"
                  
                  hide-default-footer
                >
                  <template v-slot:[`item.Id`]="{ item }">
                    <b> {{ item.Version }} </b>
                  </template>

                  <template v-slot:[`item.File`]="{ item }">
                    <span class="table_style_one">
                      {{ item.FileName }}
                    </span>
                  </template>
                  <template v-slot:[`item.language`]="{ item }">
                    <span class="table_style_two">
                      {{ item.Language }}
                    </span>
                  </template>
                  <template v-slot:[`item.numberOfVersion`]="{ item }">
                    <span class="table_style_two">
                      {{ item.numberOfVersion }}
                    </span>
                  </template>
                  <template v-slot:[`item.CreatedDate`]="{ item }">
                    <span class="table_style_two">
                      {{ checkDate(item.CreatedDate) }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-menu
                      transition="scroll-y-transition"
                      offset-y
                      color="transparent"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="A1A1A6"
                          v-bind="attrs"
                          v-on="on"
                          class="mx-3"
                        >
                          mdi-dots-horizontal
                        </v-icon>
                      </template>
                      <v-card flat>
                        <v-list class="px-3 pt-1" color="transparent">
                          <v-btn
                            depressed
                            color="transparent"
                            block
                            class="d-flex justify-start"
                            @click="Download(item)"
                          >
                            <v-icon color="#646464">mdi-tray-arrow-down</v-icon>
                            <span class="ml-4 text_style">Download File</span>
                          </v-btn>
                        </v-list>

                        <v-list class="px-3 pt-1" color="transparent">
                          <v-btn
                            depressed
                            color="transparent"
                            block
                            @click="EditsubManual(item)"
                            class="d-flex justify-start"
                          >
                            <v-icon color="#646464">mdi-pencil</v-icon>
                            <span class="ml-4 text_style">Edit </span>
                          </v-btn>
                        </v-list>

                        <v-list class="px-3 pt-1" color="transparent">
                          <v-dialog v-model="dialog" persistent max-width="290">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                depressed
                                color="transparent"
                                block
                                @click="openCofirmDialog(item.Id)"
                                class="d-flex justify-start"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="#646464">mdi-delete</v-icon>
                                <span class="ml-4 text_style">Delete</span>
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="text-h5">
                                Warning
                              </v-card-title>
                              <v-card-text class="index_span_2_style"
                                >Are you sure you want to delete?</v-card-text
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="green darken-1"
                                  text
                                  @click="dialog = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  :disabled="btnloader"
                                  @click="deleteFile()"
                                >
                                  <span v-if="btnloader != true">Confirm</span>
                                  <v-progress-circular
                                    indeterminate
                                    size="20"
                                    v-else
                                    class="px-5"
                                    color="white"
                                    v-show="btnloader"
                                  ></v-progress-circular>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </template>

                  <!-- <template v-slot:[`item.actions`]="{ item }">
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        depressed
                        color="transparent"
                        class="d-flex justify-start"
                        @click="Download(item)"
                      >
                        <v-icon color="#646464">mdi-tray-arrow-down</v-icon>
                      </v-btn>
                    </v-list>
                  </template> -->
                </v-data-table>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="fetchData()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData"
        ></v-pagination
      ></v-card>
    </div>
    <!------------Update manual dialog-------------------------->
    <v-dialog v-model="UploadManualDialog" persistent max-width="600">
      <v-card v-if="UploadManualDialog">
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Upload Manual</b></span>
          <v-icon @click="UploadManualDialog = false">mdi-close</v-icon>
        </div>
        <UploadManualComponent
          :UploadManual="UploadManualDialog"
          @close="close"
        ></UploadManualComponent>
      </v-card>
    </v-dialog>
    <!------------Edit manual dialog-------------------------->
    <v-dialog v-model="EditManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Manual</b></span>
          <v-icon @click="EditManualDialog = false">mdi-close</v-icon>
        </div>
        <EditManualComponent
          :EditManual="EditManualDialog"
          @close="close"
          :editItem="editItem"
        ></EditManualComponent>
      </v-card>
    </v-dialog>
    <v-dialog v-model="EditsubManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Manual</b></span>
          <v-icon @click="EditsubManualDialog = false">mdi-close</v-icon>
        </div>
        <editsub-manual-component
          v-if="EditsubManualDialog"
          :EditSubManual="EditSubManual"
          @close="close"
        >
        </editsub-manual-component>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadManualComponent from "../../components/DigitalManual/UploadManual.component.vue";
import EditManualComponent from "../../components/DigitalManual/EditManual.component.vue";
import EditsubManualComponent from "../../components/DigitalManual/EditsubManual.component.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    UploadManualComponent,
    EditManualComponent,
    EditsubManualComponent,
  },
  computed: {
    ...mapGetters(["GetDigitalManuals"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetDigitalManuals.length
        : this.itemsPerPage;
    },
  },

  data() {
    return {
      fileId: null,
      UploadManualDialog: false,
      loadDetails: null,
      EditManualDialog: false,
      EditsubManualDialog: false,
      filterDialog: false,
      downloadSrc: "",
      filename: "",
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 1,
      editItem: null,
      itemsPerPage: 10,
      valid: false,
      dialog: false,
      isPlaying: false,
      editvideodialog: false,
      singleExpand: true,
      newcategorydialog: false,
      expanded: null,
      organizedialog: false,
      SeeProfileDialog: false,
      tableLoader: false, // data-table true or false
      add_dialog: false,
      btnloader: false,
      test: true,
      NameCategory: "",
      Language: "",
      search: "",

      headers: [
        { text: "Title", value: "Title" },
        {
          text: "Number of Languages",
          value: "numberOfLanguage",
          sortable: false,
        },
        {
          text: "Number of Versions",
          value: "numberOfVersion",
          sortable: false,
        },
        { text: "Last Updated", value: "ModifiedDate" },
        { text: "", value: "actions", sortable: false },
      ],
      headers2: [
        { text: "Version #", value: "Id" },
        { text: "File Name", value: "File" },
        { text: "Language", value: "Language" },
        { text: "Upload Date", value: "CreatedDate" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      Fitems: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    Download(item) {
      const Id = item.Id;
      let baseUrl = process.env.VUE_APP_IMG_URL;
      this.$store.dispatch("GetDownloadDigitalManualFile", Id).then(() => {
        window.open(`${baseUrl + "file.zip"}`);
      });
    },
    openCofirmDialog(fileId) {
      this.fileId = fileId;
      this.dialog = true;
    },
    deleteFile() {
      this.btnloader = true;
      this.$store
        .dispatch("DeleteDigitalManualFile", this.fileId)
        .then((res) => {
          if (res.Status) {
            this.fetchData();
            this.dialog = false;
            this.btnloader = false;
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Deleted Successfully",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
    },
    GoToArchived(item) {
      this.$store.dispatch("AddArchivedDigitalManula", item).then(() => {
        this.fetchData();
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Archive successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    checkDate(x) {
      return moment(x).format("MM/DD/YY");
    },
    EditItem(item) {
      console.log("editItem ", item);
      this.editItem = item;
      this.EditManualDialog = true;
    },
    DeleteItem(item) {
      this.editItem = item;
    },
    deletedialog() {
      this.$store.dispatch("DeleteDigitalManual", this.editItem.Id).then(() => {
        this.btnloader = false;
        this.close();
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Manual edit successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      });
      this.dialog = false;
    },
    close(cancel) {
      if (!cancel) {
        this.fetchData();
      }
      this.UploadManualDialog = false;
      this.EditManualDialog = false;
      this.EditsubManualDialog = false;
    },
    fetchData() {
      this.tableLoader = true;
      var obj = {
        page: this.page,
        pageSize: this.itemsPerPage,
        search: this.search,
      };
      this.$store.dispatch("GetDigitalManuals", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          console.log("All Data", res);
          this.pageCount = 1;
        }
      });
    },
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;
          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.organizedialog = false;
        this.btnloader = false;
        this.newcategorydialog = false;
        this.editvideodialog = false;
      }, 2000);
    },
    EditsubManual(item) {
      console.log("item ", item);
      this.EditSubManual = item;
      this.EditsubManualDialog = true;
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.text_trans {
  text-transform: none;
}
</style>
